import { useSocialShareLinks } from '@hooks';
import { Property } from '@model';
import { useTranslation } from 'react-i18next';

type SocialShareWidgetProps = {
  property?: Property;
  size?: 'lg';
};

export const SocialShareWidget = ({ property }: SocialShareWidgetProps) => {
  const { t } = useTranslation();

  const socialShareLinks = useSocialShareLinks(property);

  return (
    <div className='ltn__social-media'>
      <ul>
        <li>{t('socialShareWidget.share')}:</li>
        {socialShareLinks.map((link) => (
          <li key={link.title}>
            <a
              href={link.href}
              title={link.title}
              target='_blank'
              rel='noopener noreferrer'
              onClick={link.onClick}
            >
              {link.icon}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
